import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import NewAccountFilterBlock from '@/views/payManage/newAccountManage/components/NewAccountFilterBlock.vue';
import NewAccountTableBlock from '@/views/payManage/newAccountManage/components/NewAccountTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tableRef = ref(null);
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(NewAccountFilterBlock, {
        onFilterSubmit: filterSubmit
      }), _createVNode(NewAccountTableBlock, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});